const DOCUMENT = 'ACCREDITATIONS_';

const actions = {
  LOAD_DATA_REQUEST: DOCUMENT + 'LOAD_DATA_REQUEST',
  LOAD_DATA_SUCCESS: DOCUMENT + 'LOAD_DATA_SUCCESS',
  DELETE_REQUEST: DOCUMENT + 'DELETE_REQUEST',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD_DATA_REQUEST,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_DATA_SUCCESS,
    payload: data,
  }),

  deleteRequest: data => ({
    type: actions.DELETE_REQUEST,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
